

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import MyAccountOverviewPart from './MyAccount_overviewPart.js';
import MyAccountGsmPart from './MyAccount_gsmPart';
import { setCache } from '../../General/Actions.js';

class MyAccountComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            billingName: "",
            contactNumber: "",
            accountId:"",
            currentActiveSubMenu: "OVERVIEW",
            isFloatingSubMenuVisible: false
        }
    }

    componentDidMount() {
        this.props.setCache("isAddFnFAddon",this.props.feature)
        window.addEventListener('scroll', this.handleScroll);
        this.initializeQuerySubscriber(this.props.cache.querySubscriberResponse);
        if(this.props.feature === "addAddon"){
            var currentServiceDetails = this.props.cache.dataForMyAccountRedirection
            this.subMenuClicked(currentServiceDetails.type,currentServiceDetails.serviceId,currentServiceDetails.serviceAddress);
        } else if(this.props.feature === "addFnFAddon"){
            var currentServiceDetails = this.props.cache.dataForMyAccountRedirection
            this.subMenuClicked(currentServiceDetails.type,currentServiceDetails.serviceId,currentServiceDetails.serviceAddress);
        }
    }

    initializeQuerySubscriber(receivedResponse) {
        var params = [];
        try {
            params = receivedResponse.profile_info.basic_details;
        } catch (err) {
            params = [];
        }

        var firstName = "";
        var lastName = "";
        var finalContactNumber = "";
        for (var i = 0; i < params.length; i++) {
            if (params[i].id  === "first_name") {
                firstName = params[i].value;
            }
            if (params[i].id  === "last_name") {
                lastName = params[i].value;
            }
            if (params[i].id  === "contact_number_1") {
                finalContactNumber = params[i].value;
            }
        }
        this.setState({
            billingName: firstName+" "+lastName,
            contactNumber: finalContactNumber
        });
        try{
            var accountInfo = receivedResponse;
            var accountInfoParams =accountInfo.account_info.param;
            var finalAccountId = "";
            for (var j = 0; j < accountInfoParams.length; j++) {
                if (accountInfoParams[j].id  === "account_id") {
                    finalAccountId = accountInfoParams[j].value;
                }
            }
            this.setState({
                accountId: finalAccountId
            });
        } catch(err){

        }
    }

    handleScroll = (event) => {
        if (window.scrollY > 190) {
            this.setState({ isFloatingSubMenuVisible: true });
        } else {
            this.setState({ isFloatingSubMenuVisible: false });
        }
    }

    subMenuClicked = (type,receivedServiceId,serviceAddress,isAddFnFAddon) => {
        this.setState({ currentActiveSubMenu: type,serviceId:receivedServiceId, serviceAddress:serviceAddress, isAddFnFAddon: isAddFnFAddon});
        // if (window.scrollY > 0) {
        //     window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        //     setTimeout(() => {
        //         this.setState({ currentActiveSubMenu: type });
        //     }, 500);
        // } else {
        //     this.setState({ currentActiveSubMenu: type });
        // }
    }

    render() {
        return (
            <div className="animated fadeIn">
                <div id="myAccountMainContainer">
                    {this.state.isLoading  === true ? <LoadingAnimation isVisible={true} /> : this.renderSubAccountContentPart()}
                </div>
            </div>
        );
    }

    renderSubAccountContentPart() {
        if (this.state.currentActiveSubMenu  === "OVERVIEW") {
            return (<MyAccountOverviewPart  subMenuClicked={this.subMenuClicked}/>);
        } else if ((this.state.currentActiveSubMenu).toUpperCase()  === this.props.locales.productFamilyNameForVoice.toUpperCase()) {
            return (<MyAccountGsmPart currentServiceDetails={{currentServiceId:this.state.serviceId,serviceAddress:this.state.serviceAddress}}/>);
        } else {
            return (<div>unspecified service</div>);
        }
    }
}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        }
    }
}

const MyAccountComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(MyAccountComponent)

export default MyAccountComponentContainer;
